import { FlashDomains, SaasCloudDomains, StorkDomains } from '../enums';

export const AUTHENTICATION_COOKIE_NAME = 'Authorization';
export const AUTH_HEADER = 'Authorization';
export const REFRESH_COOKIE_NAME = 'Refresh';
export const REFRESH_HEADER = 'x-refresh-token';
// Token exchange: reply with only the access token, without setting cookies or rotating the refresh token
export const SKIP_COOKIES_HEADER = 'x-skip-cookies';
export const V1_DOMAIN_ISSUERS = [SaasCloudDomains.prod, SaasCloudDomains.test];
export const V2_DOMAIN_ISSUERS = [FlashDomains.prod, FlashDomains.test, StorkDomains.prod, StorkDomains.test];
